import { render, staticRenderFns } from "./ProviderCreate.vue?vue&type=template&id=680c58b4"
import script from "./ProviderCreate.vue?vue&type=script&lang=ts"
export * from "./ProviderCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports